// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"b3876a4f","267":"25449bdd","275":"25449bdd","371":"38ef4709"}[chunkId] + ".chunk.css";
};